import React, { useContext } from "react";
import { Grid, GridColumn, GridRow, LabeledText } from "sprint-common-web";

import { MuxSpecificationDashboardContext } from "../context/MuxSpecificationDashboardContext";
import { ensureIsGpacMuxSpecification } from "../MuxSpecificationDashboardItem";

export const GpacMuxSpecificationTechnicalContent: React.VFC = () => {
    const { muxSpecificationDashboardItem } = useContext(MuxSpecificationDashboardContext);
    ensureIsGpacMuxSpecification(muxSpecificationDashboardItem);

    return (
        <Grid>
            <GridRow>
                <GridColumn lg={15}>
                    <LabeledText label={"Command "} value={muxSpecificationDashboardItem.command} />
                    <LabeledText
                        label={"Soundtracks command"}
                        value={muxSpecificationDashboardItem.soundtracksCommand}
                    />
                    <LabeledText label={"Subtitles command "} value={muxSpecificationDashboardItem.subtitlesCommand} />
                </GridColumn>
            </GridRow>
        </Grid>
    );
};
